import { Path } from "@common/constans";
import { IMedia, INews } from "@common/models/CMS";
import { Card, CardAction, CardContent, CardHeader, CardMedia } from "@components/general/card";
import Translate from "@service/Translate";
import { formatToDate } from "@utilize/Format";
import { FC } from "react";
import { useHistory } from "react-router";
import Button from "./general/form/Button";
import Label from "./general/Label";

interface INewsItemProps {
    news: INews;
}

const NewsItem: FC<INewsItemProps> = ({ news }) => {
    const { push } = useHistory();
    const { tr } = Translate;

    const onShareNewsClick = () => {
        navigator
            .share({
                title: tr("mahan_air"),
                text: `${news.displayText}\n${tr("publish_date")}: ${formatToDate(Number(new Date(news.publishedUtc || "")), { format: "d M Y" })}`,
                url: `${window.location}/${news.localization?.localizationSet}`
            })
            .then(() => {
                console.log('Successfully shared');
            })
            .catch(error => {
                console.error('Something went wrong sharing the blog', error);
            });
    }

    return (
        <Card variant="vertical">
            <CardMedia
                source={news.figure || {} as IMedia}
                onClick={() => push(`${Path.News}/${news.localization?.localizationSet}`)}
            />
            <CardHeader
                title={news.displayText}
                onClick={() => push(`${Path.News}/${news.localization?.localizationSet}`)}
            />
            <CardContent>
                <p>{news.summary}</p>
            </CardContent>
            <CardAction>
                <Label
                    icon="icon-calendar-outline"
                    mode="inline"
                    text={formatToDate(Number(new Date(news.publishedUtc || "")), { format: "d M Y" }) || ""}
                    size="large"
                />
                <div className="btn-action">
                    <Button
                        icon="icon-whatsapp"
                        width="35px"
                        height="35px"
                        target="_blank"
                        url={`https://wa.me?text=${encodeURIComponent(
                            `*${tr("mahan_air")}*\n`+
                            `${news.displayText}\n`+
                            `_${tr("publish_date")}: *${formatToDate(Number(new Date(news.publishedUtc || "")), { format: "d M Y" })}*_\n\n`+
                            `${window.location}/${news.localization?.localizationSet}`
                            )}`}
                        rounded
                    />
                    <Button
                        icon="icon-news-telegram"
                        width="35px"
                        height="35px"
                        target="_blank"
                        url={`https://t.me/share/url?url=`+
                            encodeURIComponent(
                            `**${tr("mahan_air")}**\n`+
                            `${news.displayText}\n`+
                            `${tr("publish_date")}: **${formatToDate(Number(new Date(news.publishedUtc || "")), { format: "d M Y" })}**\n\n`+
                            `${window.location}/${news.localization?.localizationSet}`
                            )}
                        rounded
                    />
                    <Button
                        className="share"
                        icon="icon-share"
                        width="35px"
                        height="35px"
                        target="_blank"
                        onClick={() => onShareNewsClick()}
                        rounded
                    />
                </div>
            </CardAction>
        </Card>
    )
}

export default NewsItem